<template>
  <el-main>
    <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
      <el-form-item label="推荐新闻：" prop="main_push_article">
        <div>
          <vuedraggable
            v-bind="{
              animation: 200,
              group: 'description',
              disabled: false,
              ghostClass: 'ghost',
              scroll: true,
            }"
          >
            <transition-group>
              <div class="itemBox mb20" v-for="(item, index) in ruleForm.main_push_article" :key="index">
                <el-input disabled v-model="item.title"></el-input>
                <el-button type="primary" @click="ShowGoodsDialog(index)">选择</el-button>
                <img
                  class="closeImg"
                  @click="delItem('main_push_article', index)"
                  v-if="ruleForm.main_push_article.length > 1"
                  src="https://boweisou.oss-cn-shenzhen.aliyuncs.com/enterpriseShop/close.png"
                  alt=""
                />
              </div>
            </transition-group>
          </vuedraggable>
          <div>
            <el-button type="text" @click="clickAdd('main_push_article')">+ 添加推荐新闻</el-button>
            <span class="tips">仅支持五篇新闻</span>
          </div>
        </div>
      </el-form-item>
    </el-form>
    <!-- 选择新闻 -->
    <el-dialog title="选择新闻" :visible.sync="goodsDialog" width="52%">
      <div class="chooseShopBox">
        <div class="searchBox">
          <el-input v-model="goodsConfig.search" placeholder="请输入新闻名称"></el-input>
          <el-button type="primary" @click="searchGoods">搜索</el-button>
        </div>
        <div class="showAllList" @scroll="loadPageMore">
          <div class="showAllItem" v-for="(item, index) in allGoodsList" :key="index">
            <div class="info">
              <img :src="item.picture" alt="" />
              <div>{{ item.title }}</div>
            </div>
            <div>{{ item.classify_name }}</div>
            <el-button type="text" @click="chooseGoods(item)">选择</el-button>
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 保存按钮 -->
    <Preservation @preservation="Preservation"></Preservation>
  </el-main>
</template>

<script>
import vuedraggable from 'vuedraggable';
import Preservation from '@/components/preservation';
import _ from 'lodash';
export default {
  components: {
    vuedraggable,
    Preservation,
  },
  data() {
    function mainCheck(rule, value, callback) {
      let flag = true;
      for (let i = 0; i < value.length; i++) {
        if (!value[i].id) {
          flag = false;
          break;
        }
      }
      if (!flag) {
        callback(new Error('请选择推荐新闻'));
      } else {
        callback();
      }
    }
    return {
      ruleForm: {
        main_push_article: [{}],
      },
      rules: {
        main_push_article: [{ required: true, validator: mainCheck, trigger: 'change' }],
      },
      goodsDialog: false,
      type: 'main_push_article',
      chooseIndex: -1,
      allGoodsList: [],
      goodsConfig: {
        search: '',
        page: 1,
        rows: 10,
        total: 0,
      },
    };
  },
  created() {
    this.getInfo();
  },
  methods: {
    searchGoods() {
      this.goodsConfig.page = 1;
      this.allGoodsList = [];
      this.getGoodsList();
    },
    ShowGoodsDialog(index) {
      this.goodsConfig = {
        search: '',
        page: 1,
        rows: 10,
        total: 0,
      };
      this.allGoodsList = [];
      this.getGoodsList();
      this.chooseIndex = index;
      this.goodsDialog = true;
    },
    loadPageMore(e) {
      if (e.currentTarget.scrollTop + e.currentTarget.clientHeight >= e.currentTarget.scrollHeight) {
        // 业务逻辑...
        if (this.goodsConfig.total / this.goodsConfig.rows > this.goodsConfig.page) {
          this.goodsConfig.page++;
          this.getGoodsList();
        }
      }
    },
    getGoodsList() {
      let obj = {
        page: this.goodsConfig.page,
        rows: this.goodsConfig.rows,
        is_show: 2,
      };
      if (this.goodsConfig.search) obj.title = this.goodsConfig.search;
      this.$axios.post(this.$api.set.listArticle, obj).then(res => {
        if (res.code == 0) {
          this.allGoodsList = this.allGoodsList.concat(res.result.list);
          this.goodsConfig.total = res.result.total_number;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    delItem(type, index) {
      this.ruleForm[type].splice(index, 1);
    },
    clickAdd(type) {
      let len = this.ruleForm.main_push_article.length;
      if (!this.ruleForm.main_push_article[len - 1].id) {
        this.$message.warning('请先选择新闻再进行添加');
        return;
      }
      if (len === 5) {
        this.$message.warning('最多只能推荐五篇新闻');
        return;
      }
      this.ruleForm[type].push({});
    },
    chooseGoods(data) {
      delete data.details;
      this.ruleForm.main_push_article[this.chooseIndex] = data;
      this.goodsDialog = false;
    },
    Preservation() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let obj = _.cloneDeep(this.ruleForm);
          this.$axios.post(this.$api.OfficeWebsite.setBaseInfo, obj).then(res => {
            if (res.code === 0) {
              this.$message.success('设置成功');
            } else {
              this.$message.error(res.msg);
            }
          });
        }
      });
    },
    getInfo() {
      this.$axios.post(this.$api.Tikmall.getInfo).then(res => {
        if (res.code === 0) {
          if (res.result.info) {
            for (const key in this.ruleForm) {
              if (res.result.info[key]) this.ruleForm[key] = JSON.parse(res.result.info[key]);
            }
          }
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.el-main {
  min-height: 100%;
  background-color: #fff;
  padding-bottom: 80px;
  .mb20 {
    margin-bottom: 20px;
  }
  .tips {
    color: #9f9f9f;
    font-size: 12px;
    margin-left: 20px;
  }
  .el-form {
    .itemBox {
      &:last-child {
        margin-bottom: 0;
      }
      display: flex;
      align-items: center;
      .el-input {
        width: 400px;
      }

      .closeImg {
        width: 20px;
        height: 20px;
        margin-left: 20px;
        cursor: pointer;
      }
    }
  }
  .chooseShopBox {
    .searchBox {
      display: flex;
      align-items: center;
    }
    .showAllList {
      height: 390px;
      width: 100%;
      overflow-y: auto;
      margin-top: 20px;
      .showAllItem {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 4px 20px;
        margin: 6px 0;
        .info {
          display: flex;
          align-items: center;
          img {
            width: 50px;
            height: 50px;
            margin-right: 20px;
          }
          div {
            width: 200px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
      .showAllItem:hover {
        background-color: #faf5f5ef;
      }
    }
  }
}
</style>
